import type {
  CornerDotType,
  CornerSquareType,
  DotType,
  DrawType,
  ErrorCorrectionLevel,
  Mode,
  ShapeType,
  TypeNumber,
} from 'qr-code-styling'

// Use ?inline to force base64 data URL — avoids cross-origin canvas tainting
// when qr-code-styling draws this image onto a <canvas>
import flashImage from 'assets/logo/brand-mark-black.png?inline'

export const qrOptions = (url: string) => ({
  type: 'canvas' as DrawType,
  shape: 'square' as ShapeType,
  width: 300,
  height: 300,
  data: url,
  margin: 0,
  qrOptions: {
    typeNumber: 0 as TypeNumber,
    mode: 'Byte' as Mode,
    errorCorrectionLevel: 'Q' as ErrorCorrectionLevel,
  },
  imageOptions: {
    saveAsBlob: true,
    hideBackgroundDots: true,
    imageSize: 0.3,
    margin: 0,
  },
  dotsOptions: { type: 'square' as DotType, color: '#000000', roundSize: true },
  backgroundOptions: { round: 0, color: '#FFFFFF' },
  image: flashImage,
  cornersSquareOptions: {
    type: 'square' as CornerSquareType,
    color: '#000000',
  },
  cornersDotOptions: { type: 'square' as CornerDotType, color: '#000000' },
})
